import Image from '@ui/image'
import { Row } from '@ui/wrapper'
import {
  PageHeaderWrap,
  StyledTitle,
  StyledDesc,
  StyledBG,
  StyledCol
} from './style'

const PageHeader = ({ data }) => {
  return (
    <PageHeaderWrap>
      <Row textAlign="left" style={{ position: 'relative' }}>
        <StyledCol>
          {data.images?.[0]?.src && (
            <StyledBG>
              <Image
                src={data.images?.[0]?.src.localFile || data.images?.[0]?.src}
                alt={data.images[0]?.alt || 'Page Header'}
                sizes="(max-width: 768px) 1920px, 2560px"
              />
            </StyledBG>
          )}
          {data?.headings?.[0] && (
            <StyledTitle
              color={data.headings[0]?.color}
              dangerouslySetInnerHTML={{
                __html: data.headings[0].content
              }}
            />
          )}
          {data?.texts?.[0] && (
            <StyledDesc>{data.texts[0]?.content}</StyledDesc>
          )}
        </StyledCol>
      </Row>
    </PageHeaderWrap>
  )
}

export default PageHeader
